import React from 'react';
import { Box, Typography } from '@mui/material';
import '../Docs.css'
export default function AccountCreation() {
  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h2" gutterBottom>Account Creation</Typography>
      <Typography paragraph>
PostSheet makes it easy to send emails, SMS, and WhatsApp messages to contact lists from spreadsheets or tables, automatically customizing each message using the data from the corresponding columns for each recipient.      </Typography>
      <Typography paragraph>
        To create an account, sign in with your Google account using Google Auth. This account will serve as the sender identity for all email campaigns. Make sure to grant all requested permissions to access the full range of PostSheet features.
      </Typography>
      <img src='../../static/docs/SignIn.jpg' className="step-img"/>
  
    </Box>
  );
}